(function(){
    'use strict';
    angular.module('Services').factory('ScanSummaryHelperService', ScanSummaryHelperService);
    ScanSummaryHelperService.$inject = [];

    function ScanSummaryHelperService() {
        return {
            getScanSummary: (scanSummary) => {
                if (!scanSummary.scanned && !scanSummary.pending) {
                    return {
                        type: 'summary',
                        summary: [
                            {
                                label: 'No Packages To Scan', 
                                value: null,
                                class: 'text-error'
                            }
                        ]
                    }
                }
                return {
                        type: 'summary',
                        summary: [
                            {label: 'Pending:', value: scanSummary.pending},
                            {label: 'Scanned:', value: scanSummary.scanned},
                            {
                                label: 'Status:', 
                                value: !scanSummary.pending ? 'Completed':'Incomplete',
                                class: !scanSummary.pending ? 'text-light-green':'text-error'
                            }
                        ]
                    }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/Utilities/ScanSummaryHelperService.js